import actionTypes from './action-types';
import { fetchGeolocation } from './api';
import { setCurrencyIfNotChosen } from 'tradera-state/multi-currency/actions';
import { removeShippingCountryCookieIfSwedish } from 'tradera-state/shipping-region/actions';
import { API_ERRORS } from 'tradera-utils/api';
import { logger } from 'packages/logger';
import getInitialState from './initial-state';

export const initialize = initData => ({
    type: actionTypes.INITIALIZE,
    payload: getInitialState(initData)
});

export const initializeServerMember = member => ({
    type: actionTypes.INITIALIZE,
    payload: member
});

export const defaultAction = data => ({
    type: actionTypes.DEFAULT_ACTION,
    payload: data
});

const setIsFetchingGeolocation = isFetchingGeolocation => ({
    type: actionTypes.SET_IS_FETCHING_GEOLOCATION,
    payload: {
        isFetchingGeolocation
    }
});

const setGeolocation = payload => ({
    type: actionTypes.SET_GEOLOCATION,
    payload
});

const failedLoadingGeolocation = () => ({
    type: actionTypes.FAILED_LOADING_GEOLOCATION
});

export const setMemberHeroImage = payload => ({
    type: actionTypes.SET_MEMBER_HERO_IMAGE,
    payload
});

export const getGeolocation = () => (dispatch, getState) => {
    dispatch(setIsFetchingGeolocation(true));
    const { PUBLIC_GEO_PUBLIC_API_BASE_URL } = getState().environment.variables;
    return fetchGeolocation(PUBLIC_GEO_PUBLIC_API_BASE_URL)
        .then(response => {
            const { data } = response;
            dispatch(setGeolocation(data));
            dispatch(setCurrencyIfNotChosen(data.currency));
            dispatch(setIsFetchingGeolocation(false));
            dispatch(removeShippingCountryCookieIfSwedish(data));
            return data;
        })
        .catch(error => {
            switch (error.message) {
                case API_ERRORS.ABORTED:
                case API_ERRORS.CANCELLED:
                case API_ERRORS.NETWORK:
                    break;
                default:
                    logger(error);
                    break;
            }
            dispatch(failedLoadingGeolocation());
        });
};
